
import { useSmartQuery } from "@shared/api/queries/hooks";
import { useMutation } from "@tanstack/react-query";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { AuthApi, getNscResponseTimeConfiguration } from "./api";

// Add your feature-specific hooks here
export const useAuth = () => {
  // Define your hooks
  return {};
};

// Utility Info Hook
export const useUtilityInfo = (
  params: { tenant_alias: string; utility_alias: string },
  options?: { enabled?: boolean }
) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.login.utilityInfo(params),
    () => AuthApi.getUtilityInfo(params),
    {
      refetchInterval: false,
      ...options,
    }
  );
};

// Consumer Web Login Hook
export const useConsumerWebLogin = () => {
  return useMutation({
    mutationFn: (payload: any) => AuthApi.consumerWebLogin(payload),
  });
};

// Generate OTP Hook
export const useGenerateOtp = () => {
  return useMutation({
    mutationFn: (payload: { email: string; remote_utility_id: number }) => AuthApi.generateOtp(payload),
  });
};

//Verify OTP Hook
export const useVerifyOtp = () => {
  return useMutation({
    mutationFn: (payload: any) => AuthApi.verifyOtp(payload),
  });
};

//ConsumerDetail Hook 
export const useConsumerDetail = (
  params: { remote_utility_id: any; consumer_no: string },
  options?: { enabled?: boolean }
) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.login.consumerDetail(params),
    () => AuthApi.getConsumerDetail(params),
    {
      refetchInterval: false,
      ...options,
    }
  );
};

//reset password hook
export const useResetPassword = () => {
  return useMutation({
    mutationFn: (payload: any) => AuthApi.resetPassword(payload),
  });
};


export const fetchNscConfigIfNeeded = async (utilityId: string | number) => {
  // ✅ Run only if utilityId is valid
  if (!utilityId) {
    console.warn(":warning: Skipping NSC config fetch — invalid utility ID");
    return;
  }

  const storedConfig = localStorage.getItem("NSC-Configuration");
  if (storedConfig) return; // ✅ Already saved, skip API call

  try {
    const response = await getNscResponseTimeConfiguration(String(utilityId));
    localStorage.setItem("NSC-Configuration", JSON.stringify(response));
    console.log("NSC-Configuration", JSON.stringify(response));
    console.log(":white_check_mark: NSC configuration saved to localStorage");
  } catch (err) {
    console.error(":x: Failed to fetch NSC configuration:", err);
  }
};
  
